var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.50016 0.416016C3.66683 0.416016 0.833496 0.770182 0.833496 3.24935V9.97852C0.833496 11.3456 1.94558 12.4577 3.31266 12.4577L2.49808 13.2723C2.2785 13.4918 2.43433 13.8743 2.75308 13.8743H3.52516C3.61725 13.8743 3.70933 13.8389 3.77308 13.7681L5.0835 12.4577H7.91683L9.22725 13.7681C9.291 13.8318 9.38308 13.8743 9.47516 13.8743H10.2472C10.566 13.8743 10.7218 13.4918 10.4952 13.2723L9.68766 12.4577C11.0547 12.4577 12.1668 11.3456 12.1668 9.97852V3.24935C12.1668 0.770182 9.3335 0.416016 6.50016 0.416016ZM3.31266 11.041C2.72475 11.041 2.25016 10.5664 2.25016 9.97852C2.25016 9.3906 2.72475 8.91602 3.31266 8.91602C3.90058 8.91602 4.37516 9.3906 4.37516 9.97852C4.37516 10.5664 3.90058 11.041 3.31266 11.041ZM5.79183 6.08268H2.25016V3.24935H5.79183V6.08268ZM9.68766 11.041C9.09974 11.041 8.62516 10.5664 8.62516 9.97852C8.62516 9.3906 9.09974 8.91602 9.68766 8.91602C10.2756 8.91602 10.7502 9.3906 10.7502 9.97852C10.7502 10.5664 10.2756 11.041 9.68766 11.041ZM10.7502 6.08268H7.2085V3.24935H10.7502V6.08268Z",
    fill: "#5448C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrain);
export default __webpack_public_path__ + "static/media/train.28fe23b8d8769e9af8c2af6eff9cd481.svg";
export { ForwardRef as ReactComponent };